/**
 * Strong Back: the stat grant in this column.
 *
 * Strength is carry capacity in kilos, which is a different lever from `carryKg` multiplying it.
 * Taking both is the intended stack, and neither knows the other exists.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const STRONG_BACK = {
  id: 'strongBack',
  branch: 'scavenging',
  tier: 1,
  title: 'Strong Back',
  blurb: 'Lift with the legs. Then with the back. Then with whatever is left. Strength up.',
  maxRanks: 2,
  minLevel: 3,
  requires: [],
  statGrants: { strength: 1 },
  effects: [],
  damageModifiers: [],
} as const satisfies Perk;
